<template>
  <div class="content">
    <el-form
      class="form"
      :model="ruleForm"
      ref="form"
      label-width="110px"
      label-position="right"
      :rules="rules"
      :disabled="formDisabled"
    >
      <el-form-item label="标题" prop="title">
        <el-input placeholder="请填写标题" v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item label="副标题" prop="subtitle">
        <el-input placeholder="请填写副标题" v-model="ruleForm.subtitle"></el-input>
      </el-form-item>
      <el-form-item label="时间" prop="publishedTime">
        <el-date-picker
          v-model="ruleForm.publishedTime"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="所属年度" prop="year">
        <el-date-picker
          v-model="ruleForm.year"
          type="year"
          format="yyyy"
          value-format="yyyy"
          placeholder="选择年度"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="ruleForm.type" clearable placeholder="请选择类型">
          <el-option
            v-for="item in levelOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="新闻内容" prop="content">
        <editor
          refName="content"
          :placeholderText="'请填写新闻内容'"
          v-model="ruleForm.content"
          :upload-url="uploadURL"
          :img-show-url="imgUrl"
          :disabled="formDisabled"
        ></editor>
      </el-form-item>
      <el-form-item label="封面图" prop="logo">
        <el-upload
          class="avatar-uploader"
          :action="this.uploadURL"
          name="file"
          :show-file-list="false"
          :file-list="logo"
          :on-success="
            (response, file, fileList) => handlePictureCardPreview(response, file, fileList, 'logo')
          "
          :before-upload="beforeAvatarUpload"
          :disabled="formDisabled"
        >
          <img v-if="ruleForm.logo" :src="logo[0].url" class="img_border" />
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"
            :class="{ is_border: !ruleForm.logo }"
          ></i>
          <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
          <span v-else class="upload_btn">更换图片</span>
        </el-upload>
        <span class="del_img" v-show="ruleForm.logo && !formDisabled">
          <i class="el-icon-error" @click="deleteImg('logo')"></i>
        </span>
      </el-form-item>
      <el-form-item label="发布" prop="publishedFlag">
        <el-switch v-model="ruleForm.publishedFlag" active-text="是" inactive-text="否"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import editor from "@/components/tinymce-editor/tinymce-editor";

export default {
  props: ['formDisabled', 'messageId'],
  components: {
		editor,
	},
  data() {
    return{
      limit: 1,
      levelOptions: [{
					value: 1,
					label: "新闻动态",
				},
				{
					value: 2,
					label: "行业聚焦",
				}
			],
      ruleForm: {
        title: '', // 新闻标题
        subtitle: '', // 新闻副标题
        publishedTime: '', // 发布时间
        year: '', // 所属年度
        type: 1,  // 新闻类型：1动态新闻, 2行业聚焦,示例值(2)
        content: '', // 新闻内容
        logo: '', // 封面图
        publishedFlag: false
      },
      rules: {
				title: [{
					required: true,
					message: "请填写标题",
					trigger: "blur"
				}, ],
				publishedTime: [{
					required: true,
					message: "请选择日期",
					trigger: "change"
				}, ],
				year: [{
					required: true,
					message: "请选择年度",
					trigger: "change"
				}, ],
				type: [{
					required: true,
					message: "请选择类型",
					trigger: "change"
				}, ],
				content: [{
					required: true,
					message: "请输入新闻内容",
					trigger: "blur"
				}],
				introduction: [{
					required: true,
					message: "请输入众创空间简介",
					trigger: "blur"
				}],
				standard: [{
					required: true,
					message: "请输入服务介绍与收费标准",
					trigger: "blur",
				}],
        logo: [{
					required: true,
					message: "请选择logo",
					trigger: "change"
				}],
			},
      logo: []
    }
  },
  created() {
    if(this.messageId) {
      this.initDate(this.messageId)
    }
  },
  methods: {
    initDate(id) {
      this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/news/get?id=${id}`)
        .then((res) => {
          if (res.code == 0) {
            const data = res.data;
            this.logo = data.logo ? JSON.parse(res.data.logo) : []
            data.year = data.year + ''
            data.publishedFlag = Boolean(data.publishedFlag)
            this.ruleForm = data
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });
    },
    deleteImg() {
      this.logo = []
      this.ruleForm.logo = null
    },
    beforeAvatarUpload(file) {
			let type = false;
			if (
				file.type === "image/jpeg" ||
				file.type === "image/png" ||
				file.type === "image/jpg" ||
				file.type === "image/gif" ||
				file.type === "image/bmp"
			) {
				type = true;
			}

			const isLt2M = file.size / 1024 / 1024 < 30;
			if (!type) {
				this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
			}
			if (!isLt2M) {
				this.$message.error("上传图片大小不能超过 30MB!");
			}
			return type && isLt2M;
		},
    handlePictureCardPreview(response, file, fileList, type) {
      console.log(fileList)
			// this.ruleForm.logo = file.data.store_result;
      if (response.code == 0) {
        let arr = []
        if(fileList.length > 0) {
          // fileList.map(item => {
            arr.push({
              url: file.size ? this.imgUrl + file.response.data.store_result : file.url,
              name: file.name
            });
          // });
        }
        if(arr.length > 0) {
          this[type] = arr;
          this.ruleForm[type] = JSON.stringify(arr);
        }else{
          this.ruleForm[type] = '';
          this[type] = [];
        }
      }
		},
    parentHandleclick(e) {
      this.$refs.form.validate((val) => {
        if (val) {
          const params = {
            ...this.ruleForm,
            publishedFlag: this.ruleForm.publishedFlag ? 1 : 0
          }
          e && e(params)
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  .del_img {
    position: absolute;
    top: -7px;
    left: 220px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }
  /deep/ {
    .el-input,
    .el-select {
      width: 100%;
    }
  }

  /deep/ .el-upload {
    width: 243px;
    height: 198px;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }

  /deep/ .upload-demo {
    margin-top: 10px;
    /deep/.el-upload {
      /deep/.el-button {
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        background: rgba(66, 141, 255, 1);
        border-radius: 18px;
        padding: 10px 25px;
      }
    }
  }
}
</style>
